import { render, staticRenderFns } from "./BookingDataTable.vue?vue&type=template&id=6b93a632"
import script from "./BookingDataTable.vue?vue&type=script&lang=js"
export * from "./BookingDataTable.vue?vue&type=script&lang=js"
import style0 from "./BookingDataTable.vue?vue&type=style&index=0&id=6b93a632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports